// Central content for Barrhaven Beauty Lounge
// NOTE: Placeholder contact details — update with real business info.

export const BUSINESS = {
  name: "Barrhaven Beauty Lounge",
  phoneDisplay: "+1 (613) 843-1703",
  phoneHref: "tel:+16138431703",
  email: "hello@barrhavenbeautylounge.com",
  address: "80 Marketplace Ave, Nepean, ON",
  addressFull: "80 Marketplace Ave, Nepean, ON K2J 4H9 (Inside TradeSecrets Barrhaven)",
  // Update BOOKING_URL with your real Fresha / Square / Vagaro booking link.
  bookingUrl: "https://salonpos.tappyone.com/book/barrhaven-lounge",
  instagram: "https://instagram.com",
  mapEmbed:
    "https://www.google.com/maps?q=80+Marketplace+Ave,+Nepean,+ON+K2J+4H9&output=embed",
  hours: [
    { day: "Monday – Wednesday", time: "11:00 AM – 6:00 PM" },
    { day: "Thursday – Friday", time: "11:00 AM – 7:00 PM" },
    { day: "Saturday", time: "11:00 AM – 6:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  announcement:
    "#JoinTheBarrhavenBeautyLounge - Book Your Consultation Today.",
};

export const IMAGES = {
  heroPortrait:
    "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interior:
    "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYmVhdXR5JTIwc2Fsb24lMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODUzNjQ0NzV8MA&ixlib=rb-4.1.0&q=85",
  product:
    "https://images.unsplash.com/photo-1633793565985-c52033d0e9f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBza2luY2FyZSUyMGNvc21ldGljJTIwcHJvZHVjdHxlbnwwfHx8YmxhY2t8MTc4NTM2NDQ3NXww&ixlib=rb-4.1.0&q=85",
  gallery1:
    "https://customer-assets-0z36b82j.emergentagent.net/job_afc7f1c7-8d9c-4027-a3c0-f0dccbbdfd87/artifacts/9nm0ntkb_WhatsApp%20Image%202026-07-29%20at%206.05.36%20PM.jpeg",
  gallery2:
    "https://customer-assets-0z36b82j.emergentagent.net/job_afc7f1c7-8d9c-4027-a3c0-f0dccbbdfd87/artifacts/gj9hphw2_WhatsApp%20Image%202026-07-29%20at%205.50.50%20PM.jpeg",
  logo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_afc7f1c7-8d9c-4027-a3c0-f0dccbbdfd87/artifacts/kdac5nrb_image.png",
};

const SERVICE_IMAGES = {
  laser: "/services/laser.jpg",
  facial: "/services/facial.jpg",
  ipl: "/services/ipl.jpg",
  wax: "/services/waxing.jpg",
  brow: "/services/threading.jpg",
  cosmetic:
    "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  piercing: "/services/piercing.jpg",
  combo:
    "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    slug: "laser-hair-removal",
    title: "Laser Hair Removal",
    tagline: "Smooth, radiant, long-lasting results.",
    image: SERVICE_IMAGES.laser,
    intro:
      "Our advanced laser technology delivers safe, gentle hair reduction tailored to your skin and hair type. Built-in cooling keeps every session comfortable while targeting hair during its active growth cycle for lasting smoothness.",
    highlights: [
      "Advanced cooling for comfort",
      "Personalised treatment plans",
      "Face & full-body areas",
    ],
    faqs: ["laser-1", "laser-2", "laser-3", "laser-4", "laser-5"],
  },
  {
    slug: "facials",
    title: "Custom & Korean Facials",
    tagline: "Hydrated, balanced, glowing skin.",
    image: SERVICE_IMAGES.facial,
    intro:
      "Every facial is tailored to your skin's unique needs, addressing dehydration, dullness, clogged pores, texture and fine lines. We use high-quality Korean skincare known for hydration, nourishment and visible, radiant results.",
    highlights: [
      "High-quality Korean skincare",
      "Fully customised to your skin",
      "Little to no downtime",
    ],
    faqs: ["skin-1", "skin-2", "skin-3", "before-3"],
  },
  {
    slug: "ipl-skin-rejuvenation",
    title: "IPL Skin Rejuvenation",
    tagline: "Brighter, more refreshed complexion.",
    image: SERVICE_IMAGES.ipl,
    intro:
      "IPL (Intense Pulsed Light) rejuvenation improves the appearance of sun damage, pigmentation, redness, uneven tone and signs of aging — promoting a brighter, more even and refreshed complexion.",
    highlights: [
      "Targets pigmentation & redness",
      "Evens skin tone",
      "Advanced light technology",
    ],
    faqs: ["skin-4", "skin-5", "before-1"],
  },
  {
    slug: "waxing",
    title: "Waxing",
    tagline: "Clean, smooth, and precise.",
    image: SERVICE_IMAGES.wax,
    intro:
      "Expert full-body and facial waxing performed with care and precision for smooth, long-lasting results. Our gentle techniques keep you comfortable while leaving skin soft and refined.",
    highlights: ["Full-body & facial waxing", "Gentle, precise technique", "Long-lasting smoothness"],
    faqs: ["before-2", "before-3"],
  },
  {
    slug: "threading-brows",
    title: "Threading & Brows",
    tagline: "Precision shaping, defined brows.",
    image: SERVICE_IMAGES.brow,
    intro:
      "Precision eyebrow threading and shaping to frame your face beautifully. Add tinting and lamination for fuller, defined, camera-ready brows that last.",
    highlights: ["Precision eyebrow threading", "Brow tinting & lamination", "Face-framing shaping"],
    faqs: ["exp-1", "exp-2"],
  },
  {
    slug: "cosmetic-treatments",
    title: "Cosmetic Treatments",
    tagline: "Dermaplaning, microneedling, lash & brow.",
    image: SERVICE_IMAGES.cosmetic,
    intro:
      "Enhance your natural beauty with our advanced treatments: dermaplaning for a smooth glow, microneedling for renewed texture, lash lifts for effortless definition, and eyebrow lamination for full, sculpted brows.",
    highlights: [
      "Dermaplaning & microneedling",
      "Lash lifts & brow lamination",
      "Tailored to your goals",
    ],
    faqs: ["skin-5", "before-3", "exp-1"],
  },
  {
    slug: "piercing",
    title: "Ear Piercing",
    tagline: "Safe, gentle, professional.",
    image: SERVICE_IMAGES.piercing,
    intro:
      "Professional ear piercing performed in a clean, comfortable environment with careful attention to placement, hygiene and aftercare so you leave confident and cared for.",
    highlights: ["Hygienic & professional", "Careful placement", "Full aftercare guidance"],
    faqs: ["exp-1", "exp-2"],
  },
  {
    slug: "combo-packages",
    title: "Combo Packages",
    tagline: "A complete beauty experience.",
    image: SERVICE_IMAGES.combo,
    intro:
      "Combine multiple treatments in a single visit for a complete, curated beauty experience. Our team will recommend the best combination based on your goals and skin needs.",
    highlights: ["Curated treatment pairings", "Save time in one visit", "Personalised recommendations"],
    faqs: ["exp-3", "exp-1"],
  },
];

export const TEAM = [
  {
    name: "Sheeney",
    role: "Founder",
    founder: true,
    bio: "As a mom of three girls, I know how easy it is to put yourself last. Over time, I've learned that self-care isn't a luxury—it's essential to feeling confident, balanced, and at your best. That belief inspired me to create Barrhaven Beauty Lounge—a refined yet welcoming sanctuary where women can experience premium skincare and beauty treatments close to home, without compromise on quality, results, or affordability. We are dedicated to delivering exceptional care through experienced estheticians who combine expertise with thoughtful, personalized attention. Every detail is designed to help you feel seen, supported, and renewed. It would be our privilege to welcome you in and offer a moment of calm, confidence, and care.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_serenity-beauty-ott/artifacts/h12hq11m_Sheeney%20Chen.jpeg",
  },
  {
    name: "Rabia",
    role: "Licensed Esthetician · 15+ Years",
    bio: "I'm a passionate licensed esthetician with over 15 years of experience, dedicated to helping clients feel confident in their skin. I specialise in laser hair removal, advanced skincare, and personalised treatments, creating a relaxing, results-driven experience for every client.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_serenity-beauty-ott/artifacts/xyn7zcve_Rabia.jpeg",
  },
  {
    name: "Huda",
    role: "Laser Technician",
    bio: "New to the beauty industry, I am a dedicated laser technician passionate about helping clients achieve smooth, radiant, long-lasting results. I specialise in safe, gentle laser hair removal tailored to your needs. My goal is to keep you comfortable, informed and confident while delivering high-quality care in a welcoming environment.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_serenity-beauty-ott/artifacts/s9luub2h_Huda.jpeg",
  },
  {
    name: "Sujata",
    role: "Senior Esthetician · 12+ Years",
    bio: "With over 12 years of experience in the beauty industry, I'm committed to helping every client feel refreshed and confident. My expertise includes customised facials, precision eyebrow threading, full-body waxing and ear piercings. I enjoy creating a welcoming environment where clients can relax while receiving professional, detail-oriented care.",
    image: "/team/sujata.jpg",
  },
  {
    name: "Goldy",
    role: "Licensed Esthetician · 13+ Years",
    bio: "I'm a licensed esthetician with over 13 years of experience, passionate about helping clients look and feel their best. I specialise in facials, eyebrow threading and waxing, and take pride in providing gentle, personalised care in a warm and welcoming environment.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_serenity-beauty-ott/artifacts/3lis3bsu_Goldy.jpeg",
  },
  {
    name: "Marina",
    role: "Laser Technician",
    bio: "Marina is young, passionate, and has a genuine love for all things beauty and skincare. She is excited to begin her journey with the Barrhaven Beauty Lounge team and help clients feel confident and beautiful in their own skin. With her friendly personality and enthusiasm for learning, Marina is dedicated to providing a comfortable and positive experience for every client. We're so excited to have her as part of our team!",
    image: "/team/marina.jpg",
  },
];

export const FAQ_GROUPS = [
  {
    category: "Laser Hair Removal",
    items: [
      {
        id: "laser-1",
        q: "Does laser hair removal hurt?",
        a: "Most clients describe laser hair removal as a quick snapping or warming sensation. Our advanced technology includes cooling features to help keep treatments comfortable. Sensitivity can vary depending on the treatment area, but our team will always prioritise your comfort throughout your appointment.",
      },
      {
        id: "laser-2",
        q: "How many laser hair removal treatments will I need?",
        a: "The number of treatments varies depending on your hair colour, thickness, skin type, hormones and the treatment area. Most clients see the best results after a series of sessions spaced several weeks apart, allowing us to target hair during its active growth cycle.",
      },
      {
        id: "laser-3",
        q: "How long does it take to see results from laser hair removal?",
        a: "Many clients notice a reduction in hair growth after their first few treatments. With each session, hair typically becomes finer, lighter and grows back more slowly. Consistency is key for achieving your best results.",
      },
      {
        id: "laser-4",
        q: "Can I shave between laser hair removal sessions?",
        a: "Yes! Shaving is recommended between treatments. However, avoid waxing, threading or tweezing, as these remove the hair follicle that the laser needs to target.",
      },
      {
        id: "laser-5",
        q: "Who is a good candidate for laser hair removal?",
        a: "Laser hair removal can be a great option for many clients looking to reduce unwanted hair. During your consultation, our team will assess your skin type, hair characteristics and goals to determine if treatment is right for you.",
      },
    ],
  },
  {
    category: "Skin Treatments",
    items: [
      {
        id: "skin-1",
        q: "What skin concerns can your facials help with?",
        a: "Our customised facials are designed to address a variety of concerns including dehydration, dullness, clogged pores, uneven texture, fine lines, sensitivity and overall skin health. Every treatment is tailored to your skin's unique needs.",
      },
      {
        id: "skin-2",
        q: "What makes a Korean facial different from a regular facial?",
        a: "Korean skincare focuses on achieving healthy, balanced, glowing skin through hydration, nourishment and gentle yet effective techniques. Our Korean-inspired treatments combine professional skincare products with customised techniques to leave your skin refreshed and radiant.",
      },
      {
        id: "skin-3",
        q: "How often should I book a facial?",
        a: "For ongoing skin health, we typically recommend professional facials every 4–6 weeks. Your esthetician can create a personalised schedule based on your skin goals and concerns.",
      },
      {
        id: "skin-4",
        q: "What is IPL skin rejuvenation and what does it treat?",
        a: "IPL (Intense Pulsed Light) skin rejuvenation is an advanced treatment designed to improve the appearance of sun damage, pigmentation, redness, uneven skin tone and signs of aging. It helps promote a brighter, more refreshed complexion.",
      },
      {
        id: "skin-5",
        q: "Is there downtime after your skin treatments?",
        a: "Downtime depends on the treatment performed. Many of our facials have little to no downtime, while advanced treatments may require some temporary redness or skin sensitivity. Your esthetician will provide detailed aftercare instructions to support your results.",
      },
    ],
  },
  {
    category: "Before Your Appointment",
    items: [
      {
        id: "before-1",
        q: "Do I need a consultation before my first treatment?",
        a: "We recommend a consultation for advanced treatments so we can understand your goals, review your skin history, answer your questions and create a treatment plan designed specifically for you.",
      },
      {
        id: "before-2",
        q: "How do I prepare for my appointment?",
        a: "Preparation depends on your service. For laser hair removal, shaving the treatment area before your appointment is recommended. For skin treatments, we will provide personalised preparation instructions when booking.",
      },
      {
        id: "before-3",
        q: "Can I combine multiple treatments in one visit?",
        a: "Yes! Many clients enjoy combining treatments to create a complete beauty experience. Our team can recommend the best combination based on your goals and skin needs.",
      },
    ],
  },
  {
    category: "Your Barrhaven Beauty Lounge Experience",
    items: [
      {
        id: "exp-1",
        q: "Why choose Barrhaven Beauty Lounge?",
        a: "At Barrhaven Beauty Lounge, we believe beauty treatments should be both effective and relaxing. Our experienced estheticians provide personalised care, advanced techniques and professional recommendations in a welcoming environment where every client feels valued.",
      },
      {
        id: "exp-2",
        q: "How do I book my appointment?",
        a: "Booking your appointment is easy. Contact Barrhaven Beauty Lounge and our team will help you choose the right treatment, answer any questions and schedule your personalised beauty experience.",
      },
      {
        id: "exp-3",
        q: "Do you offer combination and package treatments?",
        a: "Yes — our combo packages let you enjoy multiple treatments in one visit. Ask our team for the best pairing to match your goals and budget.",
      },
    ],
  },
];

export const ALL_FAQS = FAQ_GROUPS.flatMap((g) => g.items);

export const OFFERS = [
  {
    title: "New Client Special",
    detail: "Enjoy 15% off your first facial or laser consultation when you visit us for the first time.",
    tag: "New Clients",
  },
  {
    title: "Monthly Promotions",
    detail: "Rotating seasonal offers on our most-loved treatments. Follow us to never miss a deal.",
    tag: "Limited Time",
  },
  {
    title: "Rewards Club",
    detail: "Earn points on every visit and redeem them toward your favourite services and products.",
    tag: "Loyalty",
  },
  {
    title: "Gift Cards",
    detail: "The perfect gift of self-care. Available in any amount for the beauty lover in your life.",
    tag: "Gifting",
  },
];

export const PRODUCTS = [
  {
    name: "Hydrating Korean Serum",
    category: "Skincare",
    note: "Deep hydration & glow",
    image: IMAGES.product,
  },
  {
    name: "Barrier Repair Cream",
    category: "Skincare",
    note: "Nourish & protect",
    image:
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Gentle Cleansing Gel",
    category: "Cleanser",
    note: "For all skin types",
    image:
      "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Radiance Vitamin C",
    category: "Treatment",
    note: "Brighten & even tone",
    image:
      "https://images.unsplash.com/photo-1615900119312-2acd3a71f3aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const STORY_CHAPTERS = [
  {
    num: "01",
    title: "A calm, elegant space",
    body: "Barrhaven Beauty Lounge was founded with a simple goal: to create a calm, elegant space where beauty and self-care come together. As part of our trusted Barrhaven beauty services, we focus on enhancing your natural features and providing personalised skincare treatments in a peaceful, professional environment.",
  },
  {
    num: "02",
    title: "Expertise, refined",
    body: "For years, we have offered expert waxing, threading and custom facials designed to refresh and nourish the skin. Our facials and skincare treatments are tailored to individual needs, and we are now happy to add advanced laser hair removal and skin rejuvenation, bringing modern technology into our services to deliver even better results.",
  },
  {
    num: "03",
    title: "Korean skincare, elevated",
    body: "Our space has been updated to feel more calm and comfortable, helping you relax the moment you walk in. We have also elevated our facial treatments with high-quality Korean skincare — known for its innovation and visible results — enhancing the overall experience of every treatment.",
  },
  {
    num: "04",
    title: "Advanced & expanded",
    body: "We now also offer lash lifts, eyebrow lamination, dermaplaning and microneedling. Alongside our expanded laser hair removal options, each service is designed to enhance your natural beauty with care and precision — making us a go-to destination for Barrhaven beauty services.",
  },
  {
    num: "05",
    title: "Every detail matters",
    body: "At Barrhaven Beauty Lounge, every detail matters. Every treatment is tailored to you, from facials to advanced skincare and laser hair removal, and every client is treated with care and attention. Our goal is to help you leave feeling refreshed, glowing and confident in your skin.",
  },
];
